import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, EMPTY, throwError } from 'rxjs';

// Opts a single request out of the error toast, for polling that would otherwise raise one
// on every tick of an outage. The error is still rethrown so the caller can handle it.
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(MessageService);
  const silent = req.context.get(SKIP_ERROR_TOAST);
  return next(req).pipe(
    catchError(err => {
      if (silent) {
        return throwError(() => err);
      }
      if ((/api\/features/g.test(err.url)) && (err.status === 404 || err.status === 0)) {
        return EMPTY
      }
      if (err.status === 423) {
        // resource is locked - send to the next handler
        return throwError(() => err)
      }
      if (err.status === 409 && /orders\/[0-9]+\/save/g.test(err.url)) {
        // existing order request - handled by order management tracker
        return throwError(() => err)
      }
      if ((/api\/unlock/g.test(err.url)) && err.status === 400) {
        // An exception for unlock where the response is the user name of the lock holder
        if (err.error !== "Error") {
          toast.add({
            severity: 'warn',
            summary: `Warning`,
            detail: `Attempting to unlock this item failed because the lock is held by ${err.error}`,
            key: 'main',
            life: 5000
          });
          return EMPTY
        }
      }
      if (err.url !== 'https://graph.microsoft.com/v1.0/me/photo/$value' && !(/user-avatar/g.test(err.url))) {
        if (err.status === 401) {
          return throwError(() => err);
        } else {
          toast.add({
            severity: 'error',
            summary: `${err.status === 0 ? 'Network:' : err.status} ${err.statusText}`,
            detail: `${err.url} ${err.error?.message ? ' \r\n' + err.error.message : ''}`,
            key: 'main',
            life: 5000
          });
          // return the error so a client level handler can catch it
          return throwError(() => err);
        }
      }
      // exception for avatar
      return EMPTY
    })
  )
};
